require("./bootstrap");

import Vue from "vue";

import Vuelidate from "vuelidate";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Notifications from "vue-notification";
import vSelect from "vue-select";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Autocomplete from "vuejs-auto-complete";
import VueSplide from "@splidejs/vue-splide";
import SweetModal from "sweet-modal-vue/src/plugin.js";
import CKEditor from "@ckeditor/ckeditor5-vue2"; // CK Editor Plugin
import VueMask from "v-mask";

Vue.use(VueMask);

Vue.use(CKEditor); // CK Editor Plugin

Vue.use(VueSplide);
Vue.use(Vuelidate);
Vue.use(VueGoogleAutocomplete);
Vue.use(Notifications);
Vue.use(SweetModal);

Vue.component('vue-google-autocomplete', VueGoogleAutocomplete); // package component
Vue.component('pagination', require('laravel-vue-pagination')); // Laravel Vue Pagination
Vue.component("v-select", vSelect); // vue-select plugin
Vue.component("vue-dropzone", vue2Dropzone); // vue-dropzone-2
Vue.component("vue-autocomplete", Autocomplete); // vue-autocomplete
Vue.component("direct-property-calculation", require("./components/Valuation/DirectPropertyValuation.vue").default);
Vue.component("property-valuation-form-one", require("./components/Valuation/PropertyValuationStepOne.vue").default);
Vue.component("property-valuation-form-two", require("./components/Valuation/PropertyValuationStepTwo.vue").default);
Vue.component("property-valuation-form-three", require("./components/Valuation/PropertyValuationStepThree.vue").default);
Vue.component("property-valuation-form-four", require("./components/Valuation/PropertyValuationStepFour.vue").default);
Vue.component("property-valuation-form-five", require("./components/Valuation/PropertyValuationStepFive.vue").default);
Vue.component("property-valuation-form-six", require("./components/Valuation/PropertyValuationStepSix.vue").default);
Vue.component("property-valuation-form-seven", require("./components/Valuation/PropertyValuationStepSeven.vue").default);

// Vue.component("property-valuation-form-eight", require("./components/Valuation/PropertyValuationStepEight.vue").default);
Vue.component("property-valuation-form-eight", require("./components/Valuation/PropertyValuationStepEightUpdated.vue").default);


Vue.component("property-valuation-form-nine", require("./components/Valuation/PropertyValuationStepNine.vue").default);
Vue.component("property-valuation-form-ten", require("./components/Valuation/PropertyValuationStepTen.vue").default);

Vue.component("property-valuation-appointment", require("./components/Appointments/ValuationAppointment.vue").default);
Vue.component("property-valuation-final-offer", require("./components/Valuation/PropertyValuationFinalOffer.vue").default);
Vue.component("property-valuation-appointment-form-one", require("./components/Valuation/ScheduleFormOne.vue").default);
Vue.component("property-valuation-appointment-form-one", require("./components/Valuation/ScheduleFormOne.vue").default);

Vue.component("wait-list-form", require("./components/WaitList/WaitListForm.vue").default);
Vue.component("wait-list-confirmation", require("./components/WaitList/WaitListConfirmation.vue").default);

const app = new Vue({
    el: "#app"
});